import type { AppState } from '../../store/types';
import { getIsNltfAvailable } from '../settings/select_features';
import type { NltfState } from './types';

const selectNltf = (state: AppState): NltfState => state.nltf;

/**
 * The effective active state of AI-enriched (NL2F) search. When the user has
 * not made an explicit choice, AI-enriched is the default whenever the feature
 * is enabled.
 */
export const selectIsNltfActive = (state: AppState): boolean => {
  const modePreference = selectNltf(state).modePreference;
  if (modePreference == null) {
    return getIsNltfAvailable(state);
  }
  return modePreference === 'ai';
};

export const selectNltfIsLoading = (state: AppState): boolean =>
  selectNltf(state).isLoading;
